module.exports = __webpack_public_path__ + "img/switch-role-bg-shui.b736d31e.png";